import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.4999 11.99C51.0899 5.22999 38.8799 1.22998 31.7799 1.22998C24.6799 1.22998 12.3599 5.22999 6.94992 11.99C-2.74008 24.1 3.8699 50.74 3.8699 50.74C3.8699 50.74 4.5299 29.1599 11.7999 22.7799C17.9899 17.3399 23.6699 19.4299 31.7299 19.4299C39.7899 19.4299 45.4699 17.3499 51.6599 22.7799C58.9299 29.1699 59.5899 50.74 59.5899 50.74C59.5899 50.74 66.1899 24.1 56.4999 11.99Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.1601 1.79993C25.1601 1.79993 22.68 7.40997 26.15 19.47"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M17.5601 4.27991C17.5601 4.27991 13.6001 10.56 16.5701 19.97" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M14.09 6.09998C14.09 6.09998 8.80997 11.55 10.95 23.11"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.61002 11.99C6.61002 11.99 1.05003 23.27 6.00003 35"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M38.2901 1.79993C38.2901 1.79993 40.77 7.40997 37.3 19.47"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M45.8901 4.27991C45.8901 4.27991 49.8501 10.56 46.8801 19.97" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M49.3601 6.09998C49.3601 6.09998 54.6401 11.55 52.5001 23.11"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.8401 11.99C56.8401 11.99 62.4001 23.27 57.4501 35"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
